import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getMediaWallProgram} from '@apis'
import ChartBlock from '@components/chartBlock'

let weekday= ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]

const ProgtamList = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [playTimeStart, setplayTimeStart] = useState([])
    const [playName, setplayName] = useState([])
    const [playDate, setplayDate] = useState([])
    const [playWeek, setplayWeek] = useState([])
    const [waitTimeStart, setwaitTimeStart] = useState([])
    const [waitName, setwaitName] = useState([])
    const [waitDate, setwaitDate] = useState([])
    const [waitWeek, setwaitWeek] = useState([])
  
    async function queryOnlineRate() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId
      }
      const res = await getMediaWallProgram(params)
      if(res) {
        let timeList = []
        let nameList = []
        for(let i=0; i<res.data.length; i++) {
          timeList[i] = res.data[i].timeThresholdList
          nameList[i] = res.data[i].name
        }
        let TimeStart = 0
        let Timename = 0
        let timedate = new Date().toLocaleDateString().replace(/\//g, ".")
        let timeweek = weekday[new Date().getUTCDay()]
        let waitStart = '23:59:59'
        let waitname = null
        let waitdate = new Date().toLocaleDateString().replace(/\//g, ".")
        let waitweek = weekday[new Date().getUTCDay()]
        for(let i=0; i<timeList.length; i++) {
          for(let j=0; j<timeList[i].length; j++) {
            if(new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0] <= new Date().toTimeString().split(" ")[0]  
            && new Date().toTimeString().split(" ")[0] <= new Date(parseInt(timeList[i][j].playTimeEnd)).toTimeString().split(" ")[0]){
              TimeStart = new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0] + "-" + new Date(parseInt(timeList[i][j].playTimeEnd)).toTimeString().split(" ")[0]
              Timename = nameList[i]
              timedate = new Date().toLocaleDateString().replace(/\//g, ".")
              timeweek = weekday[new Date().getUTCDay()]
            } else {
              TimeStart = "暂无"
              Timename = "暂无"
              timedate = ""
              timeweek = ""
            }
            if(new Date().toTimeString().split(" ")[0] < new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0]
            && new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0] < waitStart) {
              waitStart = new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0] + "-" + new Date(parseInt(timeList[i][j].playTimeEnd)).toTimeString().split(" ")[0]
              waitname = nameList[i]
            }
          }
        }
        if(TimeStart == 0) {
          TimeStart = "暂无"
          Timename = "暂无"
          timedate = ""
          timeweek = ""
        }
        if(!waitname) {
          waitStart = '23:59:59'
          if(timeList.length) {
            for(let i=0; i<timeList.length; i++) {
              for(let j=0; j<timeList[i].length; j++) {
                if(waitStart >= new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0]) {
                  waitStart = new Date(parseInt(timeList[i][j].playTimeStart)).toTimeString().split(" ")[0]
                  waitname = nameList[i]
                }
              }
            }
            waitdate = new Date(new Date().getTime()+24*60*60*1000).toLocaleDateString().replace(/\//g, ".")
            waitweek = weekday[new Date().getUTCDay()+1]
          } else {
            waitStart = '暂无'
            waitdate = ''
            waitweek = ''
          }
        }
        setplayTimeStart(TimeStart)
        setplayName(Timename)
        setplayDate(timedate)
        setplayWeek(timeweek)
        setwaitTimeStart(waitStart)
        setwaitName(waitname)
        setwaitDate(waitdate)
        setwaitWeek(waitweek)
      }
      console.log('res--', res)
    }
    useEffect(() => {
      queryOnlineRate()
    }, [])

    return (
      <ChartBlock title="灯光秀节目表">
        <div className="pg-block active" style={{paddingBottom: 10}}>
          <div className="pg-title">
            当前亮灯情况
          </div>
          <div className="pg-time">
            {playTimeStart}&nbsp;{playDate}&nbsp;{playWeek}
          </div>
          <div className="pg-time">
            {playName}
          </div>
        </div>
        <div className="pg-block next"  style={{paddingBottom: 10}}>
          <div className="pg-title">
            下次亮灯计划
          </div>
          <div className="pg-time">
            {waitTimeStart}&nbsp;{waitDate}&nbsp;{waitWeek}
          </div>
          <div className="pg-time">
            {waitName}
          </div>
        </div>
      </ChartBlock>
    )
  })
)

export default ProgtamList